var map = {
	"./ApiKeyManage.vue": [
		5294,
		5294
	],
	"./Dashboard.vue": [
		6987,
		2032,
		6987
	],
	"./IpManagement.vue": [
		7453,
		7453
	],
	"./Login.vue": [
		2266,
		2266
	],
	"./ManualTrade.vue": [
		7700,
		7700
	],
	"./MenuPermission.vue": [
		2116,
		2116
	],
	"./RealTimeQuotes.vue": [
		5297,
		5297
	],
	"./Register.vue": [
		319,
		319
	],
	"./ScriptParser.vue": [
		3248,
		3248
	],
	"./Settings.vue": [
		1125,
		3506
	],
	"./StrategyConfig.vue": [
		2477,
		2477
	],
	"./TradeLogs.vue": [
		7786,
		7786
	],
	"./Trading.vue": [
		2960,
		2960
	],
	"./WebhookManage.vue": [
		9917,
		2032,
		9917
	],
	"./WebhookTradeLogs.vue": [
		9341,
		9341
	],
	"./system/NotifyTest.vue": [
		2669,
		2669
	],
	"./system/PortfolioDayPnlMonitor.vue": [
		8872,
		8872
	],
	"./system/PwaMessageHistory.vue": [
		5428,
		5428
	],
	"./trade/AStockSectorHeat.vue": [
		6537,
		6537
	],
	"./trade/AccountRiskPanel.vue": [
		5674,
		5674
	],
	"./trade/AssetOverview.vue": [
		4537,
		4537
	],
	"./trade/AutoFollowConfig.vue": [
		5599,
		5599
	],
	"./trade/ChinaStockManager.vue": [
		2219,
		2219
	],
	"./trade/CloseManager.vue": [
		9764,
		9764
	],
	"./trade/CustomPortfolioManage.vue": [
		2962,
		2962
	],
	"./trade/DailyProfit.vue": [
		5262,
		2032,
		5262
	],
	"./trade/EntryPriceCalculator.vue": [
		2258,
		6774,
		2258
	],
	"./trade/FutuTradeDashboard.vue": [
		9680,
		9680
	],
	"./trade/IBOrder.vue": [
		6774,
		6774,
		6639
	],
	"./trade/IBOrderManage.vue": [
		1096,
		1096,
		9573
	],
	"./trade/IBTradeConfig.vue": [
		7359,
		7359
	],
	"./trade/IBTradeDashboard.vue": [
		9408,
		9408
	],
	"./trade/MT5CopyTradeConfig.vue": [
		3763,
		3763
	],
	"./trade/MT5SymbolMap.vue": [
		4275,
		4275
	],
	"./trade/MT5Trade.vue": [
		3804,
		3804
	],
	"./trade/MarketTrend.vue": [
		5057,
		5057
	],
	"./trade/MobileBoardTvSignals.vue": [
		1176,
		1176
	],
	"./trade/OrderManagement.vue": [
		4822,
		4822
	],
	"./trade/OrderSyncConfig.vue": [
		6918,
		6918
	],
	"./trade/PortfolioAlignByServer.vue": [
		179,
		6774,
		3230,
		8381,
		5889
	],
	"./trade/PortfolioObserver.vue": [
		6497,
		6497
	],
	"./trade/PortfolioPositionsCard.vue": [
		5285,
		5285,
		7260
	],
	"./trade/PortfolioSummary.vue": [
		3539,
		3539,
		9020
	],
	"./trade/PortfolioView.vue": [
		826,
		826,
		1877
	],
	"./trade/PreMarketChecklist.vue": [
		7778,
		7778
	],
	"./trade/QmtOrder.vue": [
		3801,
		3801
	],
	"./trade/RiskPanel.vue": [
		8162,
		8162
	],
	"./trade/ServerConfig.vue": [
		4919,
		4919
	],
	"./trade/SignalHistory.vue": [
		7427,
		7427
	],
	"./trade/SignalPreview.vue": [
		6400,
		6400
	],
	"./trade/StrategyManager.vue": [
		3848,
		3848
	],
	"./trade/ThsPosition.vue": [
		629,
		629
	],
	"./trade/TradeMobileBoard.vue": [
		8648,
		6774,
		3230,
		3539,
		8381,
		1096,
		5285,
		8273
	],
	"./trade/TradingAgent.vue": [
		346,
		346
	],
	"./trade/TvSignalDebug.vue": [
		9361,
		9361
	],
	"./trade/USCompositeManage.vue": [
		9817,
		3230,
		3523
	],
	"./trade/USCompositeManageParent.vue": [
		9008,
		6774,
		3230,
		826,
		7484
	],
	"./trade/USWarRoom.vue": [
		2479,
		2479
	],
	"./trade/UnifiedTrade.vue": [
		5764,
		5764
	],
	"./trade/VendorConfig.vue": [
		7887,
		7887
	],
	"./trade/WatchlistSectorHeat.vue": [
		426,
		6774,
		426
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4235;
module.exports = webpackAsyncContext;